// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + (chunkId === 205 ? "mustache" : chunkId) + "." + {"205":"57679613","229":"90ef51ad"}[chunkId] + ".js";
};